import Service from '@ember/service';
import { waitForPromise } from '@ember/test-waiters';

export default class HelpTextService extends Service {
  bodycache: { [url: string]: string } = {};
  titlecache: { [url: string]: string } = {};
  async helpText(url: string): Promise<string> {
    if (Object.prototype.hasOwnProperty.call(this.bodycache, 'url')) {
      return this.bodycache[url] as string;
    }
    let result;
    try {
      let response = await waitForPromise(fetch(url));
      result = await response.text();
    } catch (error: unknown) {
      let namedError = error as { message: string };
      throw new Error(`Help Text for ${url} failed fetch: ` + namedError.message);
    }
    let titlestart = result.indexOf('<title>');
    let titleend = result.indexOf('</title>');
    if (titlestart !== -1 && titleend !== -1) {
      let title = result.substring(titlestart + 7, titleend);
      this.titlecache[url] = title;
    }

    let bodystart = result.indexOf('<body');
    let bodyend = result.indexOf('</body>');
    if (bodystart !== -1 && bodyend !== -1) {
      let bodyendstart = result.substring(bodystart).indexOf('>');
      let body = result.substring(bodystart + bodyendstart + 1, bodyend);
      this.bodycache[url] = body;
      return body;
    } else throw new Error(`Help Text for ${url} has no HTML body`);
  }

  async hasTitle(url: string): Promise<boolean> {
    await this.helpText(url);
    return Object.prototype.hasOwnProperty.call(this.titlecache, 'url');
  }

  async helpTitle(url: string): Promise<string> {
    await this.helpText(url);
    if (Object.prototype.hasOwnProperty.call(this.titlecache, 'url')) {
      return this.titlecache[url] as string;
    } else throw new Error(`Help Text for ${url} has no HTML title`);
  }

  toICUMessage(text: string): string {
    //TODO: Escape all < and > in text
    return text;
  }
}

declare module '@ember/service' {
  interface Registry {
    'help-text': HelpTextService;
  }
}
